import { useState, useEffect, useCallback } from "react";
import { IoAddOutline, IoMailOutline, IoTrashOutline } from "react-icons/io5";

import Modal from "../../../../components/common/Modal";
import Toaster from "./../../../../components/common/Toaster";

import EmailForm from "./components/EmailForm";
import DeleteEmail from "./components/DeleteEmail";

import accountService from "../../../../services/accountService";

const Emails = ({ id }) => {
  const [selected, setSelected] = useState(null);
  const [emails, setEmails] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const fetchReferrals = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const { result } = await accountService.getAccountSecondaryEmailsAsync(
          id
        );

        if (mounted) {
          setEmails(result);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [id]
  );

  const handleSuccess = (item) => {
    setEmails([item, ...emails]);
    setShowForm(false);
  };

  const handleSuccessDelete = (item) => {
    const updated_emails = emails.filter((i) => i.id !== item.id);
    setEmails(updated_emails);
    handleDelete();
  };

  const handleDelete = (item) => {
    setSelected(item);
    setShowDelete(!showDelete);
  };

  useEffect(() => {
    let mounted = true;

    fetchReferrals(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchReferrals]);

  return (
    <div className="p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500">Secondary Emails</p>
          <span className="text-xs text-gray-400">
            List of Secondary Emails
          </span>
        </div>
        {emails.length < 3 && (
          <IoAddOutline
            className="text-blue-500 text-lg cursor-pointer"
            onClick={() => setShowForm(true)}
          />
        )}
      </div>
      <div className="mt-6 mb-4">
        {isLoading && (
          <div className="flex-1 space-y-3 py-1 animate-pulse">
            <div className="h-4 bg-gray-100 rounded w-3/5"></div>
            <div className="h-4 bg-gray-100 rounded w-5/5"></div>
            <div className="h-4 bg-gray-100 rounded w-4/5"></div>
            <div className="h-4 bg-gray-100 rounded w-2/5"></div>
          </div>
        )}
        {!isLoading && emails.length > 0 && (
          <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
            {emails.map((item, index) => {
              return (
                <li
                  key={index}
                  className="pl-3 pr-4 py-3 flex items-center text-gray-400 text-sm group"
                >
                  <div className="w-full flex items-center">
                    <IoMailOutline />
                    <p className="ml-2">{item.email}</p>
                  </div>
                  <div className="relative mb-4 hidden group-hover:block">
                    <IoTrashOutline
                      className="absolute right-0 text-red-400 cursor-pointer"
                      onClick={() => handleDelete(item)}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        {!isLoading && emails.length === 0 && (
          <div className="text-center bg-gray-50 p-8 rounded-xl mb-2">
            <div className="flex justify-center">
              <div>
                <IoMailOutline className="text-3xl inline text-gray-300" />
                <p className="text-gray-400 text-sm mt-3">Nothing to show</p>
                <span className="text-gray-400 text-xs">No data available</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <p className="text-gray-400 text-xs text-right mt-5">
        Maximum of 3 Emails
      </p>
      <Modal
        title="Create Secondary Email"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <EmailForm
          id={id}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
      <Modal
        isOpen={showDelete}
        isLoading={isFormLoading}
        onClose={handleDelete}
      >
        <DeleteEmail
          data={selected}
          onClose={handleDelete}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccessDelete}
        />
      </Modal>
    </div>
  );
};

export default Emails;
